module.exports = __webpack_public_path__ + "static/media/GTBSProjectPreview1870@2x.90ac3531.jpg";